/*
 *
 * Configuration reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_CONFIGURATION_WATCHER,
  GET_CONFIGURATION_SUCCESS,
  GET_CONFIGURATION_FAILED,
  PUT_CONFIGURATION_WATCHER,
} from "./constants"

export const initialState = fromJS({
  configuration: {},
  isLoadingConfiguration: true,
})

function configurationReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CONFIGURATION_WATCHER:
    case PUT_CONFIGURATION_WATCHER:
      return (
        state
          // .set('configuration', {})
          .set("isLoadingConfiguration", true)
      )
    case GET_CONFIGURATION_SUCCESS:
      return state
        .set("configuration", action.payload)
        .set("isLoadingConfiguration", false)
    case GET_CONFIGURATION_FAILED:
      return state.set("configuration", {}).set("isLoadingConfiguration", false)
    default:
      return state
  }
}

export default configurationReducer
